import { loginByType } from '@/api/power-cable-auth/login'
import { activeAccount, getAccountInfo } from '@/api/power-cable-auth/account'
import { EventBus } from '@/utils/vueBus';
import {setCookie, getCookie, removeCookie} from '@/utils/yl-cookie'
import { defaultSettings } from '@/settings';
const tokenKey = defaultSettings.token.key || "token"
import { logout } from '@/api/power-cable-auth/user'

const user = {
  namespaced: true,
  state: {
    token: getCookie(tokenKey),
    username: '',
    userInfo: {},
    avatar: require('@/assets/images/头像.png'),
  },
  getters: {
    userInfo(state) {
      return state.userInfo
    },
    isLogin(state) {
      return !!(state.token)
    },
    token(state) {
      return state.token
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setCookie(tokenKey, token)
    },
    SET_NAME: (state, { username }) => {
      state.username = username
    },
    SET_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      state.username = userInfo.nickName
      state.avatar = userInfo.avatar
    },
  },
  actions: {
    login({ commit }, obj) {
      return loginByType(obj.type, obj.data).then(({ data }) => {
          if(data.code == 0){
            if (!Array.isArray(data.data)) {
              EventBus.$emit('mySocketEvent')
            }
          }
          return data
      })
    },
    activeAccount({ commit }, data){
      return new Promise((resolve, reject) => {
        activeAccount(data).then(({ data }) => {
          if (data.code == '200' || data.code == '0') {
            resolve(data)
          } else {
            reject(data)
          }
        })
      })
    },
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getAccountInfo().then(response => {
          const { data } = response.data
          if (response.data.code !== 0) {
            reject('Verification failed, please Login again.')
          }
          const { name } = data
          commit('SET_INFO', data)
          commit('SET_NAME', { username: name })
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    removeToken({ commit}) {
      commit('SET_INFO', '')
      commit('SET_NAME', '')
      commit('SET_TOKEN', '')
      EventBus.$emit('stopMySocketEvent')
      localStorage.removeItem('username')
      localStorage.removeItem('password');
      localStorage.removeItem('iframeSrc'); 
      removeCookie(tokenKey)
    },
    logout({ commit, dispatch}) {
      logout().then((res) => {
        if(res.data.code == 0){
          dispatch('removeToken')
          window.location.href = '/login'
        }
      })
    },
  }
}
export default user